import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import {SLIDES_TYPES} from '@/const';

export const initialState = {
  settings: {},
  menu: [],
  groupMenu: [],
  participantMenu: [],
  slides: {
    [SLIDES_TYPES.main]: [],
    [SLIDES_TYPES.category]: {},
    [SLIDES_TYPES.participant]: {},
    [SLIDES_TYPES.group]: {},
    [SLIDES_TYPES.attribute]: {},
  },
  pages: [],
  eventLocations: [],
  staticBlocks: {},
  attributes: [],
  ui: {
    homePage: [],
    passesPage: {},
    scheduleFilters: [],
  },
};

export default {
  state: JSON.parse(JSON.stringify(initialState)),
  mutations,
  actions,
  getters,
};
